import { FAQ } from '@tenants/types/tenant';
import { joinExpCaPaths, joinExpUsPaths, Namespaces } from 'types/locales';

export function createFaqData(namespace: typeof Namespaces.JOIN_EXP_US | typeof Namespaces.JOIN_EXP_CA, contactLink: string): FAQ {

  const faq_title: joinExpCaPaths | joinExpUsPaths = `${namespace}:faq.title`;
  const faq_q1_title: joinExpCaPaths | joinExpUsPaths = `${namespace}:faq.q1.title`;
  const faq_q1_children: joinExpCaPaths | joinExpUsPaths = `${namespace}:faq.q1.children`;
  const faq_q2_title: joinExpCaPaths | joinExpUsPaths = `${namespace}:faq.q2.title`;
  const faq_q2_children: joinExpCaPaths | joinExpUsPaths = `${namespace}:faq.q2.children`;
  const faq_q3_title: joinExpCaPaths | joinExpUsPaths = `${namespace}:faq.q3.title`;
  const faq_q3_children: joinExpCaPaths | joinExpUsPaths = `${namespace}:faq.q3.children`;
  const faq_q4_title: joinExpCaPaths | joinExpUsPaths = `${namespace}:faq.q4.title`;
  const faq_q4_children: joinExpCaPaths | joinExpUsPaths = `${namespace}:faq.q4.children`;
  const faq_q5_title: joinExpCaPaths | joinExpUsPaths = `${namespace}:faq.q5.title`;
  const faq_q5_children: joinExpCaPaths | joinExpUsPaths = `${namespace}:faq.q5.children`;
  const faq_q6_title: joinExpCaPaths | joinExpUsPaths = `${namespace}:faq.q6.title`;
  const faq_q6_children: joinExpCaPaths | joinExpUsPaths = `${namespace}:faq.q6.children`;
  const faq_q7_title: joinExpCaPaths | joinExpUsPaths = `${namespace}:faq.q7.title`;
  const faq_q7_children: joinExpCaPaths | joinExpUsPaths = `${namespace}:faq.q7.children`;

  const faqData: FAQ = {
    title: faq_title,
    content: [
      {
        title: faq_q1_title,
        children: faq_q1_children,
      },
      {
        title: faq_q2_title,
        children: faq_q2_children,
      },
      {
        title: faq_q3_title,
        children: faq_q3_children,
        styleOverrides: {
          p: {
            fontWeight: 'bold',
            marginBottom: '0.5rem',
            marginTop: '0.5rem',
          },
        },
      },
      {
        title: faq_q4_title,
        children: faq_q4_children,
      },
      {
        title: faq_q5_title,
        children: faq_q5_children,
      },
      {
        title: faq_q6_title,
        children: faq_q6_children,
      },
      {
        title: faq_q7_title,
        children: faq_q7_children,
        values: {
          contactLink,
        },
      },
    ],
  };

  return faqData;
}
